<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30 distributor-page">
    <div>
      <div class="list-wrap mg-b-15">
        <div class="list-heard d-flex mg-b-5">
          <div class="d-flex pd-x-5 flex-1 tx-white">
            <div class="c-4">{{ $t("mall.广告类型") }}</div>
            <div class="c-6">{{ $t("mall.图片") }}</div>
            <div class="c-3">{{ $t("mall.点击") }}</div>
            <div class="c-6">{{ $t("mall.参数") }}</div>
            <div class="c-3">{{ $t("mall.是否启用") }}</div>
            <div class="c-2">{{ $t("mall.操作") }}</div>
          </div>
        </div>
        <div
          v-for="(item, index) in items"
          :key="item.id + index"
          class="list-body d-flex align-items-start mg-b-10"
        >
          <div class="flex-1 pd-x-0 mg-x-5">
            <div class="card bd-gray-400 pd-5">
              <div
                class="d-flex flex-row align-items-center justify-content-start"
              >
                <div class="c-4">
                  <span class="tx-white">{{
                    $t($dict.ADtype[item.type])
                  }}</span>
                </div>
                <div class="c-6">
                  <a
                    v-if="item.pathType == 'img'"
                    class="mg-r-10 img-wrap d-block"
                    href="javascript:;"
                    v-lazy:background-image="item.imgUrl"
                    @click="preview(item.imgUrl, $dict.ADtype[item.type])"
                    :style="{
                      backgroundSize: scale[index].scale
                        ? '100% auto'
                        : 'auto 100%',
                    }"
                    style="
                      width: 90px;
                      height: 90px;
                      background-position: center;
                      background-repeat: no-repeat;
                      border: 1px solid #ddd;
                    "
                  ></a>
                  <video
                    v-else
                    id="video"
                    width="200"
                    height="100"
                    controls="controls"
                    :src="item.imgUrl"
                  ></video>
                </div>
                <div class="c-3">
                  <span class="tx-white">{{
                    $t($dict.ADclickType[item.clickType])
                  }}</span>
                </div>
                <div class="c-6">
                  <span
                    style="word-break: break-all"
                    v-if="
                      item.clickType == '1' &&
                      (item.paramsJson || {}).productName
                    "
                    class="tx-white d-block"
                    >{{ $t("mall.商品名包含：")
                    }}{{ (item.paramsJson || {}).productName }}</span
                  >
                  <span
                    style="word-break: break-all"
                    v-if="
                      item.clickType == '1' &&
                      (item.paramsJson || {}).priceRange
                    "
                    class="tx-white d-block"
                    >{{ $t("mall.价格范围段：") }}
                    <span
                      v-if="
                        (item.paramsJson || {}).min &&
                        (item.paramsJson || {}).max
                      "
                      >{{ (item.paramsJson || {}).min }}-{{
                        (item.paramsJson || {}).max
                      }}</span
                    >
                    <span v-else-if="(item.paramsJson || {}).min">
                      &ge;{{ (item.paramsJson || {}).min }}</span
                    >
                    <span v-else-if="(item.paramsJson || {}).max">
                      &le;{{ (item.paramsJson || {}).max }}</span
                    >
                  </span>
                  <span
                    style="word-break: break-all"
                    v-if="
                      item.clickType == '1' && (item.paramsJson || {}).cName
                    "
                    class="tx-white d-block"
                    >{{ $t("mall.商品标签：")
                    }}{{ (item.paramsJson || {}).cName }}</span
                  >
                  <span
                    style="word-break: break-all"
                    v-if="
                      item.clickType == '2' && (item.paramsJson || {}).urlPath
                    "
                    class="tx-white d-block"
                    >{{ (item.paramsJson || {}).urlPath }}</span
                  >
                </div>
                <div class="c-3">
                  <span class="tx-white">{{
                    $t($dict.ADStatus[item.status])
                  }}</span>
                </div>
                <div class="c-2">
                  <div v-if="isSysRights('SupplierMallAD.moveBySupplier')">
                    <a
                      href="javascript:;"
                      class="tx-info mg-r-15"
                      @click="move(item, '1')"
                      >{{ $t("mall.上移") }}</a
                    >
                    <a
                      href="javascript:;"
                      class="tx-info"
                      @click="move(item, '2')"
                      >{{ $t("mall.下移") }}</a
                    >
                  </div>
                  <div>
                    <a
                      v-if="isSysRights('SupplierMallAD.changeBySupplier')"
                      href="javascript:;"
                      class="tx-info mg-r-15"
                      @click="editAD(item)"
                      >{{ $t("mall.修改") }}</a
                    >
                    <a
                      v-if="isSysRights('SupplierMallAD.deleteBySupplier')"
                      href="javascript:;"
                      class="tx-danger"
                      @click="deleteAD(item)"
                      >{{ $t("mall.删除") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="(!items || items.length < 1) && !first_loading"
          class="col-12 none-product"
        >
          <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的广告") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  data() {
    return {
      scale: [],
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYYMMDD").format("YYYY-MM-DD");
    },
  },
  watch: {
    items: {
      handler: function () {
        this.imgScale();
      },
      deep: true,
    },
  },
  methods: {
    imgScale() {
      this.scale = [];
      let vm = this;
      if (this.items && this.items.length > 0) {
        for (let i = 0; i < this.items.length; i++) {
          this.scale.push({ scale: false, sub: [] });
          if (this.items[i].imgUrl) {
            let img = new Image();
            img.src = this.items[i].imgUrl;
            img.onload = function () {
              if (img.width > img.height) {
                if (vm.scale && vm.scale.length > 0) {
                  vm.$set(vm.scale[i], "scale", true);
                }
              }
            };
          }
        }
      }
    },
    preview(img, text) {
      this.$store.commit("setImgItem", [
        {
          img,
          text,
        },
      ]);
      this.$parent.loading = true;
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        if (viewer.images.length) viewer.show();
        this.$parent.loading = false;
      }, 500);
    },
    deleteAD(item) {
      this.$emit("deleteAD", item);
    },
    editAD(item) {
      this.$emit("editAD", item);
    },
    move(item, type) {
      this.$emit("move", item, type);
    },
  },
};
</script>
<style scoped="scoped">
.td-collapse.active + td {
  border-left: none;
}
</style>